'use client';

import type { TipDetailDto } from '@/api/backoffice-schemas';
import { InfiniteCarousel } from '../carousels/infinite';
import { VerticalTipCard } from './VerticalTipCard';

export const HighlightedTipsCarousel = ({ tips }: { tips: TipDetailDto[] }) => {
  const mobileSlideWidthPercentage = tips.length > 1 ? 90 : 100;

  return (
    <InfiniteCarousel
      slideWidthPercentage={100 / 3}
      slideWidthPercentageMobile={mobileSlideWidthPercentage}
    >
      {tips.map((item) => (
        <VerticalTipCard data={item} key={item.id} />
      ))}
    </InfiniteCarousel>
  );
};
